import { httpError } from '@/models/httpError';
import { getField, updateField } from 'vuex-map-fields';
import { HTTP } from '@/http-common';

const state = {
  auth: null,
  accessToken: null,
  isAuthenticated: false,
  message: new httpError(),
};

//ACTIONS
const actions = {
  setAuth({ commit, state }, payload) {
    commit('setAuthentication', payload);
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
  getAuths({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get('Auth/GetAuthorisations/');
      response
        .then(function (data) {
          dispatch(
            'setMessage',
            new httpError({
              httpStatus: 200,
              message: 'Retrieved OK',
            })
          );
          resolve(data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              httpStatus: 500,
              message: 'Error Retreiving:' + err.message,
            })
          );
          reject(err.message);
        });
    });
  },
  updateAuth({ commit, dispatch }, auth) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('Auth/UpdateAuthorisation/', auth);
      response
        .then((data) => {
          var resultData = data;
          dispatch(
            'setMessage',
            new httpError({
              httpStatus: 200,
              message: 'Updated',
            })
          );
          resolve(resultData);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              httpStatus: 400,
              message: 'User already exists: ' + err.message,
            })
          );
          reject(err.message);
        });
    });
  },
  addMFAToUser({ dispatch }, email) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(`/Auth/AddMFAToUser`, { email });
      response
        .then((data) => {
          dispatch(
            'setMessage',
            new httpError({
              httpStatus: 200,
              message: 'User enrolled in MFA',
            })
          );
          resolve('ok');
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              httpStatus: 400,
              message: 'Request Failed: ' + err.message,
            })
          );
          reject(err.message);
        });
    });
  },
};

//Mutations
const mutations = {
  setProgress(state, message) {
    state.message = message;
  },
  setAuthentication(state, payload) {
    state.auth = payload;
    state.isAuthenticated = true;
  },
  updateField,
};

//getters

const getters = {
  auth: (state) => state.auth,
  isAuthenticated: (state) => state.isAuthenticated,
  getField,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
